import timeZoneData from 'dashboard/routes/dashboard/settings/inbox/helpers/timezones.json';

export const ACCOUNT_TIMEZONE_OPTIONS = Object.entries(timeZoneData)
  .map(([label, value]) => ({ label, value }))
  .sort((a, b) => a.label.localeCompare(b.label));
